<template>

    <div v-if="loading" class="w-full flex justify-center mt-10">
        
        <ring-loader ></ring-loader> 
    </div>
  
    <div v-else class="bg-white border rounded-lg h-full">

        <!-- <div class="sticky top-0 bg-white"> -->
        <div class="sticky top-0 bg-white z-50">

            <div v-if="isModal" class="myCenter">

                <button 
                    class="classPageFontAwesomeButton"
                    v-on:click="closeMembershipsPage">
                            
                    <font-awesome-icon icon="times-circle" size="2x"/> 
                </button>
            </div>

            <!-- <div class="">
                
                <my-memberships-tabs :itemIsSelected="itemIsSelected" :myTabsList="tabsList"/>
            </div> -->
            
        </div>

        <div class="mb-20">

            <div v-if="tab == 1">

                 <gyms-memberships :category="category" :county="county" :location="location" 
                :myReload="myReload" :itemIsSelected="itemIsSelected" :myTabsList="tabsList"
                :myBusinessId="myBusinessId" :isFromBusinessBrowse="isFromBusinessBrowse">

                    <div class="">
                        
                        <my-memberships-tabs :itemIsSelected="itemIsSelected" :myTabsList="tabsList" :myOpenTab="tab"/>
                    </div>    
                </gyms-memberships>   
            </div>

            <div v-if="tab == 2">

                <studios-memberships :category="category" :county="county" :location="location" 
                :myReload="myReload" :itemIsSelected="itemIsSelected" :myTabsList="tabsList"
                :myBusinessId="myBusinessId" :isFromBusinessBrowse="isFromBusinessBrowse">

                    <div class="">
                        
                        <my-memberships-tabs :itemIsSelected="itemIsSelected" :myTabsList="tabsList" :myOpenTab="tab"/>
                    </div>    
                </studios-memberships>
            </div>

            <div v-if="tab == 3">

                <ma-memberships :category="category" :county="county" :location="location" 
                :myReload="myReload" :itemIsSelected="itemIsSelected" :myTabsList="tabsList"
                :myBusinessId="myBusinessId" :isFromBusinessBrowse="isFromBusinessBrowse">


                    <div class="">
                        
                        <my-memberships-tabs :itemIsSelected="itemIsSelected" :myTabsList="tabsList" :myOpenTab="tab"/>
                    </div>    
                </ma-memberships>            
            </div>

            <div v-if="tab == 4">
                
                <classes-memberships :category="category" :county="county" :location="location"
                :myReload="myReload" :itemIsSelected="itemIsSelected" :myTabsList="tabsList"
                :myBusinessId="myBusinessId" :isFromBusinessBrowse="isFromBusinessBrowse">
            
                    <div class="">
                        
                        <my-memberships-tabs :itemIsSelected="itemIsSelected" :myTabsList="tabsList" :myOpenTab="tab"/>
                    </div>                
                </classes-memberships>
            </div>
        </div>
    </div>

</template>

<script>

import myMembershipsTabs from '../../components-v2/controls/MyMembershipsTabs';

import gymsMemberships from './PublicInfoGymsMemberships';

import studiosMemberships from './PublicInfoStudiosMemberships';

import maMemberships from './PublicInfoMaMemberships';

import classesMemberships from './PublicInfoClassesMemberships';

import myQueries from '../../hasura/myQueries';
import myThreeQueries from '../../hasura/myThreeQueries';
import componentsHelpers from '../../classes/componentHelpers';

import { RingLoader } from 'vue-spinners-css';

// // import axios from '@/classes/myAxios'
import axios from '@/classes/myAxios'


export default {

    async mounted(){

        await this.loadData();

        this.$layoutType = 3;
        // console.log(`this.$layoutType: ${this.$layoutType}`);

        this.setMembershipTab();


        let result = await this.$auth.isAuthenticated();
            
            // console.log(`result: ${result}`);

            if(result == true){

                this.$router.push({ path: 'clientSubscriptions' })
            }


    },

    props:{

        myBusinessId: 0,

        isFromBusinessBrowse: false,

        isModal: false,

         closeClassPage: {

            type: Function 
        },

        // myClass:{
        
        //     type: Object,
        //     default: () => ({})
        // },

        userId: 0


    },

    components:{

        myMembershipsTabs,
        gymsMemberships,
        studiosMemberships,
        maMemberships,
        classesMemberships,
        RingLoader                   
    },

    methods:{

        async loadData(){

            try{

                const countryName = 'Kuwait';

                this.loading = true;

                let result = await axios({method: 'post',url: '/pnadiapi/forPublicInfo/getLocationAndFacilityAndCategory',
                    data: {
                    
                        countryName: countryName,
                    }
                });

            // console.log(`result.data.length: ${JSON.stringify(result.data.two_pitch_slot.length)}`);

                this.category = result.data.category;

                // console.log(`this.category: ${JSON.stringify(this.category)}`);

                this.county = result.data.location_country_county;

                this.location = result.data.location;

                this.facility = result.data.facility;

                this.loading = false;

            }catch(error){

                this.loading = false;

                componentsHelpers.sendError(this.$apollo, this.userId,'PublicInfo', 'allMemberships', 'loadData', error);

                componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

            }
        },

        setMembershipTab(){

            if(localStorage.hasOwnProperty('v2-clientMembershipSelected')){


                this.tab = Number(localStorage.getItem('v2-clientMembershipSelected'));
            // console.log(`setMembershipTab, this.tab: ${this.tab}`);

            }
            else{

                this.tab = 1;
            }

        },

        itemIsSelected(value){

            this.tab = value;

            localStorage.setItem('v2-clientMembershipSelected', value)
            // console.log(`itemIsSelected, this.tab: ${value}`);
        },

        myReload(){

            console.log(`reload go`);
            location.reload();
        },
    },

    data: function(){

        return {

            loading: false,
            tab: 4,
            tabOneName: "class",
            tabTwoName: "business",
            tabThreeName: "instructor",
            tabsList:[
               
                'gyms',
                'studios',
                'ma',
                'classes'
            ],

            category:[],
            county:[],
            location:[],
            facility:[],

            categoryMutationError: '',
            countiesError: '',
            locationError:'',
            facilityError:'',
        }
    }

}
</script>

<style>

</style>